




























import { Component, Mixins } from 'vue-property-decorator'
import * as ApiPath from '@/tcw/constant/ApiPath'
import DataGetComponent from '@/tcw/components/DataGetComponent'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import { ApiGeneralObjectArrayPayload } from '@/tcw/api/types'

@Component({
  components: { TcwLayoutBasicTemplate }
})
export default class UserListTable extends Mixins(DataGetComponent) {
  private userList: ApiGeneralObjectArrayPayload | null = null

  get apiPath(): string {
    return ApiPath.Paths.User.get
  }

  protected responseInitWebApi(response: ApiGeneralObjectArrayPayload): void {
    this.userList = response
  }

  private clickEdit(userId: number) {
    this.$router.push(`/user/input/${userId}`)
  }

  // private get sortedUserList() {

  // }
}
